<template>
	<div>
		<template v-for="(objPeople,p_index) in value">
			<div class="row">
				<label class="col-form-label col-md-12"><span>Фамилия</span></label>
				<div class="col-md-12">
					<div class="form-group">
						<div class="mb-0">
							<input type="text" placeholder="Фамилия" class="form-control" v-model.lazy="objPeople.surname">
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<label class="col-form-label col-md-12"><span>Имя</span></label>
				<div class="col-md-12">
					<div class="form-group">
						<div class="mb-0">
							<input type="text" placeholder="Имя" class="form-control" v-model.lazy="objPeople.name">
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<label class="col-form-label col-md-12"><span>Отчество</span></label>
				<div class="col-md-12">
					<div class="form-group">
						<div class="mb-0">
							<input type="text" placeholder="Отчество" class="form-control" v-model.lazy="objPeople.patronymic">
						</div>
					</div>
				</div>
			</div>

			<div class="row">
				<label class="col-form-label col-md-12"><span>Телефон</span></label>
				<div class="col-md-12">
					<ReInputContact 
						v-model="objPeople.phones" 
						:contactGroup_options="contactPhone_options" 
						contactGroup="phone"
						placeholder="Введите номер"
						errorLabel="Телефон"
						:delMethod="{}"
						:bShowView="false"
					/>
				</div>
			</div>
			<div class="row">
				<label class="col-form-label col-md-12"><span>E-mail</span></label>
				<div class="col-md-12">
					<ReInputContact 
						v-model="objPeople.emails" 
						:contactGroup_options="contactEmail_options" 
						contactGroup="email"
						placeholder="Введите почту"
						errorLabel="E-mail"
						:delMethod="{}"
						:bShowView="false"
					/>
				</div>
			</div>

			<div class="row">
				<label class="col-form-label col-md-12"><span>Семейное положение</span></label>
				<div class="col-md-12 checkbox-radios">
					<base-radio v-for="(el_opt, el_index) in masRBState" :key="el_opt.name+'_'+el_index" :name="el_opt.name" v-model="objPeople.state" inline>{{el_opt.label}}</base-radio>
				</div>
			</div>

			<div class="row mb-2">
				<label class="col-form-label col-md-12" :class="[{'formRequired':passport.required}]">{{passport.label}}</label>
				<div class="col-md-12">
					<ReFileUpload 
							v-model="objPeople.passport_files"
							:type="passport.type"
							:multiple="passport.multiple"
							:formId="'People_list_UploadForm'+'_'+Math.random()"
							:btnClass="passport.btnClass"
							:bShowTrash="passport.bShowTrash"
							:acceptMime="passport.acceptMime"
							:uploadApi="passport.uploadApi"
							:delApi="passport.delApi"
							:required="passport.required"
							v-on:change="OnUploadFile_passport($event,p_index)"
							v-on:clear="OnClear_passport($event,p_index)"
						/>
				</div>
			</div>
			<div class="row mb-2">
				<label class="col-form-label col-md-12" :class="[{'formRequired':inn.required}]"><span>{{inn.label}}</span></label>
				<div class="col-md-12">
					<ReInputINN 
							v-model="objPeople.inn"
						/>
						<!-- 
													:type="inn.type"
							:multiple="inn.multiple"
							:formId="'People_list_UploadForm'+'_'+Math.random()"
							:btnClass="inn.btnClass"
							:bShowTrash="inn.bShowTrash"
							:acceptMime="inn.acceptMime"
							:uploadApi="inn.uploadApi"
							:delApi="inn.delApi"
							v-on:change="OnUploadFile_inn($event,p_index)"
							v-on:clear="OnClear_inn($event,p_index)"
						-->
				</div>
			</div>
			<div class="row mb-2">
				<label class="col-form-label col-md-12" :class="[{'formRequired':snils.required}]"><span>{{snils.label}}</span></label>
				<div class="col-md-12">
					<ReFileUpload 
							v-model="objPeople.snils_files"
							:type="snils.type"
							:multiple="snils.multiple"
							:formId="'People_list_UploadForm'+'_'+Math.random()"
							:btnClass="snils.btnClass"
							:bShowTrash="snils.bShowTrash"
							:acceptMime="snils.acceptMime"
							:uploadApi="snils.uploadApi"
							:delApi="snils.delApi"
							:required="snils.required"
							v-on:change="OnUploadFile_snils($event,p_index)"
							v-on:clear="OnClear_snils($event,p_index)"
						/>
				</div>
			</div>
			<div class="row mb-2">
				<label class="col-form-label col-md-12" :class="[{'formRequired':other_docs.required}]"><span>{{other_docs.label}}</span></label>
				<div class="col-md-12">
					<ReFileUpload 
							v-model="objPeople.client_other_docs"
							:type="other_docs.type"
							:multiple="other_docs.multiple"
							:formId="'People_list_UploadForm'+'_'+Math.random()"
							:btnClass="other_docs.btnClass"
							:bShowTrash="other_docs.bShowTrash"
							:acceptMime="other_docs.acceptMime"
							:uploadApi="other_docs.uploadApi"
							:delApi="other_docs.delApi"
							:required="other_docs.required"
							v-on:change="OnUploadFile_other_docs($event,p_index)"
							v-on:clear="OnClear_other_docs($event,p_index)"
						/>
				</div>
			</div>

			<button class="btn btn-icon btn-simple btn-danger btn-del" @click="delPeople(p_index)" v-if="value.length>1">
				<i class="tim-icons icon-trash-simple"></i>
			</button>
			<hr>
		</template>
		<button class="btn btn-simple btn-success mt-3" @click="addEmptyPeople()">
			Добавить клиента
		</button>
	</div>
</template>

<script>
	import ReInputContact from 'src/our_components/ReInputContact.vue';
	import ReInputINN from 'src/our_components/ReInputINN.vue';
	import { BaseRadio } from 'src/components/index';
	import ReFileUpload from 'src/our_components/ReFileUpload.vue';
	export default {
		name: 'ReListOfPeople',
		components: {
			ReInputContact,
			BaseRadio,
			ReFileUpload,
			ReInputINN,
		},
		props: {
			value: {
				type:Array,
				default: function(){
					return [{
						surname:'',
						name:'',
						patronymic:'',
						phones:[],
						emails:[],
						state:0
					}];
				}
			},
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			contactPhone_options:{
				type:Array,
				default: function(){
					return [{
						'value': '1',
        				'label': 'Телефон моб.'
					},{
						'value': '2',
        				'label': 'Телефон раб.'
					}];
				}
			},
			contactEmail_options:{
				type:Array,
				default: function(){
					return [{
						'value': '11',
        				'label': 'E-mail'
					}];
				}
			},
		},
		data () {
			return {
				ver: 1,
				bUploading:false,
				masRBState:[{name:0,label:'В браке'},{name:1,label:'Холост'}],
				passport:{
					element_model:[],
					elementType:'file-upload',
					label:'Загрузить паспорт',
					type: 'file',
					multiple: true,
					acceptMime: '*/*',
					uploadApi: {apiMethod:'UniUpload',apiParam:{obj:'FileUpload',flt:{type:'ddu'}}},
					delApi: {},
				},
				inn:{
					/*
					element_model:[],
					elementType:'file-upload',
					label:'Загрузить ИНН',
					type: 'file',
					multiple: true,
					acceptMime: '* / *',  фикс если расскомментируете
					uploadApi: {apiMethod:'UniUpload',apiParam:{obj:'FileUpload',flt:{type:'ddu'}}},
					delApi: {},
					*/
					elementGetParamMap:'inn',
					element_model:'',
					elementType:'input-inn',
					label: 'ИНН',
					placeholder: '10 или 12 цифр',
					required: true,
				},
				snils:{
					element_model:[],
					elementType:'file-upload',
					label:'Загрузить СНИЛС',
					type: 'file',
					multiple: true,
					acceptMime: '*/*',
					uploadApi: {apiMethod:'UniUpload',apiParam:{obj:'FileUpload',flt:{type:'ddu'}}},
					delApi: {},
					required: true,
				},
				other_docs:{
					element_model:[],
					elementType:'file-upload',
					label:'Загрузить другие документы',
					type: 'file',
					multiple: true,
					acceptMime: '*/*',
					uploadApi: {apiMethod:'UniUpload',apiParam:{obj:'FileUpload',flt:{type:'ddu'}}},
					delApi: {},
				}
			}
		},
		computed: {

		},
		methods: {
			addEmptyPeople(){
				this.value.push({
					surname:'',
					name:'',
					patronymic:'',
					phones:[],
					emails:[],
					state:0,
					passport_files:[],
					inn_files:[],
					snils_files:[],
					client_other_docs:[],
				});
			},
			delPeople(ind){
				this.value.splice(ind,1);
			},
			OnUploadFile_passport(objUpload,p_index){
				this.OnUploadFile(objUpload,this.value[p_index].passport_files);
			},
			OnUploadFile_inn(objUpload,p_index){
				this.OnUploadFile(objUpload,this.value[p_index].inn_files);
			},
			OnUploadFile_snils(objUpload,p_index){
				this.OnUploadFile(objUpload,this.value[p_index].snils_files);
			},
			OnUploadFile_other_docs(objUpload,p_index){
				this.OnUploadFile(objUpload,this.value[p_index].client_other_docs);
			},
			OnUploadFile(objUpload,elModel){
				//console.log(objUpload);
				//console.log(elModel);
				if(objUpload == null) return false;
				if(typeof objUpload.selfObj != 'undefined'){
					if(!this.$GVO.isEmpty(objUpload.selfObj.uploadApi)){
						this.bUploading=true;
						const objIndex = objUpload.formId.match(/[0-9/.]+/)[0];
						this.$GVO.UploadFile(objUpload.formId, objUpload.selfObj.uploadApi.apiMethod, objUpload.selfObj.uploadApi.apiParam)
							.then(objApi => {
								//console.log(objApi);
								if(objApi.success){
									if(typeof objApi.data.length != 'undefined'){
										for (let i = 0; i < objApi.data.length; i++) {
											elModel.push(objApi.data[i].fullpath);
										}
									}else if(typeof objApi.data.fullpath != 'undefined'){
										elModel.push(objApi.data.fullpath);
									}
								}else{
									// console.log(objApi.msg);
								}
								this.bUploading=false;
							})
							.catch(errorObjApi => 	{  console.error(errorObjApi); this.bUploading=false;});
					}
				}
			},
			OnClear_passport(objUpload,p_index){
				this.value[p_index].passport_files = [];
			},
			OnClear_inn(objUpload,p_index){
				this.value[p_index].inn_files = [];
			},
			OnClear_snils(objUpload,p_index){
				this.value[p_index].snils_files = [];
			},
			OnClear_other_docs(objUpload,p_index){
				this.value[p_index].client_other_docs = [];
			},
		},
	}
</script>
<style scoped>
	hr{border: 2px solid #01B0E0;}
	.btn-del{float: right; margin-top: -25px;}
	.fileinput {margin: 0px 10px 0px 0px !important;}
</style>
